import styled from "@emotion/styled";

import { BaseLink } from "shared/components/common/base-link";
import { fontRobotoCondensed } from "shared/lib/styles";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

export const InstructionButton = styled.div`
  inline-size: fit-content;

  border: 1px solid rgba(255, 255, 255, 0.6);
  border-radius: 3px;
`;

export const StyledBaseLink = styled(BaseLink)`
  display: flex;
  gap: 6px;
  align-items: center;

  padding-block: 3px;
  padding-inline: 7px;

  color: rgba(255, 255, 255, 0.6);
  font-size: 15px;
  font-family: ${fontRobotoCondensed};
  line-height: 18px;
`;

export const InstructionButtonText = styled.div``;

export const InstructionText = styled.div`
  color: rgba(255, 255, 255, 0.6);
  font-size: 15px;
  font-family: ${fontRobotoCondensed};
  line-height: 18px;
`;
